import React from 'react';
export function Footer() {
  return <footer className="bg-sage-100 border-t-4 border-leaf py-10 px-4 text-center" data-id="element-120" data-mp="32wd2qgad7ltj">
      <p className="text-sm text-forest/80" data-id="element-121" data-mp="3gg0yw2enzvx4">
        © Hydroponics Grower Ready 2026 — All rights reserved.
      </p>
    </footer>;
}